import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/CloudUpload';

class CloudUploadIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CloudUploadIcon;
